import React, { Component } from 'react';
import './App.css';

import { MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from './themes';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import store, { history } from './store';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Layout from './pages/Layout';
import PublicLayout from './pages/public/PublicLayout';
import PrintableLayout from './pages/printable/PrintableLayout';
import Startup from './Startup';

import { login } from './modules/auth';

//import RequireLogin from './containers/requireLogin';
import AuthRoute from './containers/AuthRoute';

//import MyAwesomeReactComponent from './MyAwesomeReactComponent';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import {
	BrowserRouter,
	//Link,
	Route,
	Redirect,
	Switch,
} from 'react-router-dom';

import pfBackground from './images/pfBackground.jpg';
import pfLogo from './images/pearsonFuelsLogoV2.png';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import ReactCodeInput from 'react-code-input';

const styles = {
	background: {
		position: 'absolute',
		zIndex: -1,
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
	},
	bgPhoto: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundImage: `url('${pfBackground}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		opacity: 0.14,
	},
	bgTopHalf: {
		width: '100%',
		height: '60%',
		backgroundColor: theme.palette.primary[600],
	},
	bgBottomHalf: {
		width: '100%',
	},
	container: {
		margin: 0,
		width: '100%',
		height: '100%',
		position: 'absolute',
	},
	login: {
		padding: 30,
		fontSize: 18,
		color: '#888',
		fontWeight: 100,
		textTransform: 'uppercase',
	},
	loginButtonContainer: {
		paddingTop: 10,
	},
	authMessages: {
		minHeight: 50,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
	},
	loginButton: {
		fontSize: 18,
		borderRadius: '100px',
		padding: '15px 40px',
	},
};

class LoginInside extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			password: '',
			redirectToReferrer: false,
		};
	}

	loginClicked() {
		this.props.login({
			email: this.state.email,
			password: this.state.password,
			mfaCode: this.state.mfaCode,
		});
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.authSuccess && this.props.authSuccess) {
			this.setState({
				redirectToReferrer: true,
			});
		}
	}

	_onChangePassword(e) {
		this.setState({ password: e.target.value });
	}
	_onChangeMfaCode(mfaCode) {
		this.setState({ mfaCode });
	}

	_onChangeEmail(e) {
		this.setState({ email: e.target.value });
	}

	render() {
		const {
			accessToken,
			isAuthenticating,
			authSuccess,
			authFailure,
			authErrors,
			mfaCodeSent,
		} = this.props;

		if (this.state.redirectToReferrer) {
			return <Redirect to={'/dashboard'} />;
		}

		const disableLogin = isAuthenticating;

		return (
			<Grid container justify={'center'} align={'center'} style={styles.container}>
				{accessToken && <Redirect to="/dashboard" />}
				<div style={styles.background}>
					<div style={styles.bgTopHalf} />
					<div style={styles.bgBottomHalf} />
					<div style={styles.bgPhoto} />
				</div>

				<Grid item xs={12} sm={10} md={6} lg={4}>
					<Card style={{ padding: '40px 60px' }}>
						<div>
							<img alt="Logo" style={{ width: '80%' }} src={pfLogo} />
						</div>
						<div style={styles.login}>
							Fuel Management
							<br />
							Platform Login
						</div>

						{!mfaCodeSent && (
							<>
								<Grid item xs={12} style={{ textAlign: 'left' }}>
									<TextField
										value={this.state.email}
										onChange={this._onChangeEmail.bind(this)}
										label="Email"
										fullWidth
									/>
								</Grid>

								<Grid item xs={12} style={{ textAlign: 'left' }}>
									<TextField
										value={this.state.password}
										onChange={this._onChangePassword.bind(this)}
										id="password"
										label="Password"
										type="password"
										autoComplete="current-password"
										margin="normal"
										fullWidth
									/>
								</Grid>
							</>
						)}
						{!!mfaCodeSent && (
							<>
								<Grid item xs={12} style={{ textAlign: 'center' }}>
									<div style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 5 }}>
										Multi-factor Authentication
									</div>
									<div style={{ marginBottom: 5 }}>
										A one-time mfa code has been sent to your mobile phone. Please enter that below
										to login.
									</div>
									<ReactCodeInput
										name="mfaCode"
										type="text"
										fields={6}
										onChange={this._onChangeMfaCode.bind(this)}
									/>
								</Grid>
							</>
						)}

						<Grid item xs={12} style={styles.loginButtonContainer}>
							<div style={styles.authMessages}>
								{authSuccess && <div>Success</div>}
								{authFailure &&
									authErrors.map((authError, i) => {
										return <div key={i}>{authError}</div>;
									})}
								{isAuthenticating && <div>Authenticating....</div>}
							</div>
							<Button
								variant="contained"
								disabled={disableLogin}
								style={styles.loginButton}
								color="primary"
								onClick={this.loginClicked.bind(this)}
							>
								LOGIN
							</Button>
						</Grid>
					</Card>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = (state) => ({
	accessToken: state.auth.accessToken,
	isAuthenticating: state.auth.isAuthenticating,
	authErrors: state.auth.authErrors,
	authSuccess: state.auth.authSuccess,
	authFailure: state.auth.authFailure,
	mfaCodeSent: state.auth.mfaCodeSent,
});

LoginInside.propTypes = {
	accessToken: PropTypes.string,
	isAuthenticating: PropTypes.bool,
	authFailure: PropTypes.bool,
	authSuccess: PropTypes.bool,
	authErrors: PropTypes.array,
	login: PropTypes.func,
	mfaCodeSent: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			login,
		},
		dispatch
	);

const Login = connect(mapStateToProps, mapDispatchToProps)(LoginInside);

const NoMatch = ({ location }) => (
	<div>
		<h3>
			No match for <code>{location.pathname}</code>
		</h3>
	</div>
);

NoMatch.propTypes = {
	location: PropTypes.object,
};

const isMaintenance = false;

class App extends Component {
	render() {
		return (
			<Provider store={store}>
				<Startup>
					<ConnectedRouter history={history}>
						<BrowserRouter>
							<MuiThemeProvider theme={theme}>
								<MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
									<div className="App">
										{isMaintenance && (
											<div style={{ marginTop: 100, fontSize: 30 }}>
												The system is currently in maintenance mode and will be back up and running
												at shortly. Please check back. Sorry for any inconvenience.
											</div>
										)}
										{!isMaintenance && (
											<Switch>
												<Route path="/printable/*" component={PrintableLayout} />
												<Route path="/public/*" component={PublicLayout} />
												<Route path="/sms/*" component={PublicLayout} />
												<Route path="/login" component={Login} />
												<AuthRoute path="/" component={Layout} />
											</Switch>
										)}
									</div>
								</MuiPickersUtilsProvider>
							</MuiThemeProvider>
						</BrowserRouter>
					</ConnectedRouter>
				</Startup>
			</Provider>
		);
	}
}
export default App;
